import React from 'react';
import {
  toAbsoluteUrl,
  encryptId,
  formatPrice,
} from '../../../../_metronic/helpers';
import { colorStatusCuentasCobrar } from '../../../../_metronic/helpers/CustomElements';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useGetDataOrden } from '../hooks/HomeHook';

type Props = {};

const CardOrder: React.FC<Props> = ({}) => {
  const { dataOrden: data, loadingRequest: loading } = useGetDataOrden();

  const columns: any = [
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Concepto</div>,
      selector: (row: any) => row.concepto_cobro,
      cell: (row: any) => (
        <>
          <Link to={`/cobranza/cuentas_cobrar/${encryptId(row.id.toString())}`}>
            {`${row.concepto_cobro}`}
          </Link>
        </>
      ),
      width: '200px',
      sortable: true,
    },
    {
      id: 'facturacion',
      name: <div className="fw-bolder text-muted me-5">Facturación</div>,
      selector: (row: any) =>
        new Date(row.fecha_facturacion).toISOString().split('T')[0],
      cell: (row: any) => (
        <>
          <div className="text-gray-700">
            {new Date(row.fecha_facturacion).toISOString().split('T')[0]}
          </div>
        </>
      ),
      width: '150px',
      sortable: true,
    },
    {
      id: 'vigencia',
      name: <div className="fw-bolder text-muted me-5">Vigencia</div>,
      selector: (row: any) =>
        new Date(row.fecha_vencimiento).toISOString().split('T')[0],
      cell: (row: any) => (
        <>
          <div className="text-gray-700">
            {new Date(row.fecha_vencimiento).toISOString().split('T')[0]}
          </div>
        </>
      ),
      width: '150px',
      sortable: true,
    },
    {
      id: 'proyecto',
      name: <div className="fw-bolder text-muted me-5">Proyecto</div>,
      selector: (row: any) =>
        row.proyecto ? row.proyecto.nombre : 'Sin proyecto',
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <div className="d-flex justify-content-start flex-column fs-012">
            <div className={`d-flex `}>
              {row.proyecto ? row.proyecto.nombre : 'Sin proyecto'}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      id: 'cotizacion',
      name: <div className="fw-bolder text-muted me-5">Cotización</div>,
      selector: (row: any) => (row.nombre ? row.nombre : 'Sin cotización'),
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <div className="d-flex justify-content-start flex-column fs-012">
            <div className={`d-flex `}>
              {row.nombre ? row.nombre : 'Sin cotización'}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      id: 'pago',
      name: <div className="fw-bolder text-muted me-5">Pago</div>,
      selector: (row: any) =>
        row.tipoPago ? row.tipoPago.name : 'Sin tipo de pago',
      sortable: true,
      cell: (row: any) => (
        <>
          <div className="text-gray-700">
            {row.tipoPago ? row.tipoPago.name : 'Sin tipo de pago'}
          </div>
        </>
      ),
    },
    {
      id: 'total',
      name: <div className="fw-bolder text-muted me-5">Total</div>,
      selector: (row: any) => Number(row.cobro),
      cell: (row: any) => (
        <>
          <div>
            <span className="text-gray-700 fw-bolder">
              {`${formatPrice(row.cobro, 'es-MX', 'MXN', 2, 2)}`}
            </span>
            <span className="text-gray-600 ms-3 fs-8">
              {row.unidadMoneda
                ? `/ ${row.unidadMoneda.code}`
                : 'Sin unidad de moneda'}
            </span>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      id: 'estatus',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.estatus.name,
      cell: (row: any) => (
        <div
          className={`${
            row.estatus ? colorStatusCuentasCobrar(row.estatus.code) : ''
          }`}
        >
          {row.estatus ? row.estatus.name : 'N/A'}{' '}
        </div>
      ),
      sortable: true,
    },
  ];

  return (
    <>
      <div className="card card-flush h-md-100">
        <div className={`card-body d-flex flex-column`}>
          <>
            <div className="fs-1 fw-bold text-gray-800">
              <span className="me-2">
                <span className="fs-015">{'Facturas Pendientes'}</span>
              </span>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {!loading ? (
                <DataTable
                  columns={columns}
                  data={data}
                  expandableRowsHideExpander
                  responsive
                  customStyles={{
                    rows: {
                      style: {
                        borderBottom: '1px dashed #e4e6ef !important',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                      },
                    },
                    headRow: {
                      style: {
                        borderBottom: '1px dashed  #e4e6ef',
                      },
                    },
                    pagination: {
                      style: {
                        borderTopStyle: 'none',
                      },
                    },
                  }}
                  paginationComponentOptions={{
                    rowsPerPageText: 'Registros por página',
                    rangeSeparatorText: 'de',
                  }}
                  noDataComponent={
                    <>
                      <div className="d-flex align-items-center mt-20">
                        <div className="mt-20">
                          <h3 className="font-weight-mormal fs-5 timeline-content text-muted ">
                            No existen facturas pendientes
                          </h3>
                          <div className="d-flex align-items-center">
                            <img
                              className="mx-auto  h-200px"
                              src={toAbsoluteUrl(
                                '/media/illustrations/sketchy-1/bg-task-empty.png'
                              )}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  }
                ></DataTable>
              ) : (
                <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
                  <div className="text-center">
                    <h1 className="fw-semibold text-gray-800 text-center lh-lg">
                      <span
                        className="indicator-progress text-primary"
                        style={{ display: 'block' }}
                      >
                        <div className="text-center mt-3">
                          <span className="spinner-border spinner-border-lg align-middle ms-2"></span>
                        </div>
                      </span>
                    </h1>
                  </div>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export { CardOrder };
